// eslint-disable-next-line no-useless-escape
export const gitRules = /^(http(s)?:\/\/([^\/]+?\/){2}|git@[^:]+:[^\/]+?\/).*?.git$/;